// extracted by mini-css-extract-plugin
module.exports = {"uvp-banner":"uvp_uvp-banner__CQwM_","uvp-main":"uvp_uvp-main__JMT76","uvp-item":"uvp_uvp-item__zYVm6","uvp-title":"uvp_uvp-title__5L5tG"};